import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';

const logoImage = '/images/y4clogo.svg'

const Footer = () => {
  return (
    <Container className="py-5 mt-5 border-top">
      <Row className="row-cols-1 row-cols-sm-2 row-cols-md-5">
        <Col className="mb-3">
          <a href="/" className="d-flex align-items-center mb-3 text-decoration-none">
            {/* Replace with your logo component or image */}
            <span className="me-2" style={{ width: '40px', height: '32px' }}>
                          {/* Your logo SVG would go here */}
                          <img src={logoImage} />
            </span>
          </a>
          <p className="text-white">© 2025 Yoth for Change</p>
        </Col>

        <Col className="mb-3">
          {/* Empty column as in original */}
        </Col>

        <Col className="mb-3">
          <h5>Section</h5>
          <Nav className="flex-column">
            <Nav.Item className="mb-2 ">
              <Nav.Link href="#" className="p-0 text-white">Home</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Features</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Pricing</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">FAQs</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">About</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>

        <Col className="mb-3">
          <h5>Section</h5>
          <Nav className="flex-column">
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Home</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Features</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Pricing</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">FAQs</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">About</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>

        <Col className="mb-3">
          <h5>Section</h5>
          <Nav className="flex-column">
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Home</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Features</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">Pricing</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">FAQs</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mb-2">
              <Nav.Link href="#" className="p-0 text-white">About</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;